import {pdsUtils} from './pds-utils';
import {AjaxSettings} from './interfaces/ajax-settings';
import {Observable} from 'rxjs';
import {AjaxResponse} from './interfaces/AjaxResponse';
import { pdsLocalStorage } from './pds-local-storage';

type QueryParamMap = {[paramName: string]: string};
type HeaderMap = {[headerName: string]: string};

/*
  This object is meant to be a utility for wrapping ajax calls in observables.
  It is not exposed on the pds toolkit yet as it is only meant to be used internally in PDS.
  When it comes time to use this outside of PDS we will have to expose it through the PDS toolkit object.
*/
export let pdsHttpUtils = {

  get(url: string, queryParameters?: QueryParamMap, headers?: HeaderMap, disableAjaxStatus?: boolean): Observable<AjaxResponse> {
    let ajaxOptions = {
      headers: headers,
      method: 'GET',
      disableAjaxStatus: disableAjaxStatus
    };
    return request(url, ajaxOptions, queryParameters);
  },

  post(url: string, data: any, queryParameters?: QueryParamMap, headers: HeaderMap = {}, disableAjaxStatus?: boolean): Observable<AjaxResponse> {
    if (headers['content-type'] == null) {  // if content type is not defined default to json
      headers['content-type'] = 'application/json';
    }
    let ajaxOptions: AjaxSettings = {
      headers: headers,
      method: 'POST',
      data: JSON.stringify(data), // data should be a string
      disableAjaxStatus: disableAjaxStatus
    };
    return request(url, ajaxOptions, queryParameters);
  },

  addUCAuthHeader(headers:  HeaderMap): HeaderMap {
    (<any>headers).Authorization = `Bearer ${pdsLocalStorage.getItem('auth_token')}`; // the application needs to set this in local storage
    return headers;
  }
};

// these methods are not part of the exported object to keep them private

function request(url: string, settings: AjaxSettings = {}, queryParameters?: QueryParamMap): Observable<AjaxResponse> {
  if (queryParameters != null && Object.keys(queryParameters).length > 0) {
    url = addQueryParams(url, queryParameters);

  }

  return Observable.create((observer) => {
    settings.success = (data: any, xhr: XMLHttpRequest, status: string) => {
      observer.next({data: xhr.responseText, status: xhr.status});
      observer.complete();
    };

    settings.error = (xhr: XMLHttpRequest, status: string) => {
      observer.error(({data: xhr.responseText, status: xhr.status}));
      observer.complete();
    };

    pdsUtils.ajax(url, settings);
  });
}

function addQueryParams(url: string, queryParameters?: QueryParamMap): string {
  if (queryParameters != null) {
    let queryParameterKeys = Object.keys(queryParameters);
    url += '?';
    for (let i = 0; i < queryParameterKeys.length; i++) {
      let key = queryParameterKeys[i];
      url += (key + '=' + queryParameters![key]);
      if (i !== queryParameterKeys.length - 1) {
        url += '&';
      }
    }
  }
  return url;
}
